import { Card, CardContent } from '@/components/ui/card';

/// Card de KPI do painel de negócio — extraído de Business.tsx quando o
/// /business/growth (#525) passou a precisar do mesmo bloco. `hint` é a linha
/// fina opcional embaixo do valor (ex.: "N de M usuários").
export function KpiCard({
  label,
  value,
  hint,
}: {
  label: string;
  value: string | number;
  hint?: string;
}) {
  return (
    <Card>
      <CardContent className="pt-5 pb-4">
        <p className="text-xs text-muted-foreground">{label}</p>
        <p className="text-xl font-semibold mt-1 tabular-nums">{value}</p>
        {hint && <p className="text-[11px] text-muted-foreground mt-0.5">{hint}</p>}
      </CardContent>
    </Card>
  );
}
